export default {
	styleOverrides: {
		root: ({ ownerState, theme }) => ({
			[theme.breakpoints.up('xl')]: {
				// `maxWidth` is set to `1440px` on XL screens. See https://www.evedesignsystem.com/9a29ba7d4/p/918a2a-headernav/t/page-918a2a-60253131-28 for details
				maxWidth: '1440px',
			},
			...(theme.themeKey === 'internal' &&
				ownerState.variant === 'EvePageContent' && {
					[theme.breakpoints.down('xl')]: {
						padding: 0,
					},
				}),
			...(ownerState.variant === 'EveFullPage' && {
				paddingTop: theme.spacing(3),
				paddingBottom: theme.spacing(3),
				paddingLeft: theme.spacing(6),
				paddingRight: theme.spacing(6),
			}),
		}),
	},
};
